<div class="row col-12 p-0 m-0 main-page-section ">
  <div class="col-12 p-0 employee-section">
    <div class="col-height">

      <div>

        <div class="breadcrumbs-section pl-2 ml-5">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/bulk-invite-approval">Invitation Approval</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">History</span>
        </div>

        <div class="history-layout">

          <div class="row">
            <div class="col-12">
              <h1>History</h1>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p>You can access history for the last 90 days. Data beyond 90 days will be available in the reports tab.
              </p>
            </div>
          </div>

        </div>


        <div class="col-12 d-flex justify-content-start row borders m-0 p-0 ">
          <div class="col-3  borders-right d-flex justify-content-between relative-content "
            style="margin-left: -20px;">

            <div class="pt-3 pb-3" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
              [ngbPopover]="popMeetingRooms" triggers="manual" #p1="ngbPopover" (click)="openPopover(p1)"
              placement="bottom" popoverClass='dash-popover dashboard-popover'
              class=" meeting-label center-align box-size pointer-link text-center meeting-room-head">
              <div class="text" style="width: max-content;">Company Name</div>
              <img src="../../assets/images/Path.png" class="pr-3 access-point-arrow" loading="lazy" />
              <div class="font"> {{multiSelectionCompanyName.length>1?selectedCompanyName+" +"+
                selctionlength :selectedCompanyName}}</div>

              <div>
                <ng-template #popMeetingRooms>
                  <div class="dashboard-popover ">
                    <div class="">
                      <div class="">
                        <div class="row pb-3 d-flex justify-content-between pointer-link"
                          *ngFor="let item of companyList;let i=index" (click)="selectCompanyName(item);"
                          [class]="multiSelectionCompanyName.includes(item?.parkTenantId)|| (item?.parkTenantId == null && multiSelectionCompanyName.length == 0)?'bold-font':'normal-font'">
                          {{item.parkTenantName}}
                          <div>
                            <img src="/assets/images/tick.png"
                              *ngIf="multiSelectionCompanyName.includes(item?.parkTenantId) || (item?.parkTenantId == null && multiSelectionCompanyName.length == 0)"
                              class="pl-5 " loading="lazy" />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </ng-template>
              </div>
            </div>

          </div>


          <div class=" pt-3 pb-3 borders-right col-2 ">

            <div class="pl-3">
              <span class="meeting-label pt-3" style="
                            position: absolute;
                            padding-left: 31px;margin-top: -14px;">From</span>

              <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d1.toggle()" [(ngModel)]="fDate"
                ngbDatepicker #d1="ngbDatepicker" [minDate]="minDate" [maxDate]="maxDate" (dateSelect)="updateSelectedDate($event)">

              <div class="meeting-sub-label from-date">{{formattedSelectedDate}}</div>

            </div>

          </div>
          <div class="pl-3 pt-3 pb-3 col-2 borders-right  ">
            <span class="meeting-label pt-3" style="
                            position: absolute;
                            padding-left: 31px;margin-top: -14px;">To</span>

            <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d2.toggle()" [(ngModel)]="tDate" ngbDatepicker
              #d2="ngbDatepicker" (dateSelect)="updateSelectedToDate($event)" [minDate]="minDate" [maxDate]="maxDate">
            <div class="meeting-sub-label from-date">{{formattedSelectedToDate}}</div>

          </div>
          <div [ngClass]="'col-4'">
            <label for="search">
              <img loading="lazy" class=" search-layout" src="/assets/images/search.png" alt="search">
              <input class="search-box search-padding placeholder-text " type="text" name="search" id="menu-search"
                [(ngModel)]="searchText" placeholder="Type here to search…">
            </label>
          </div>

        </div>

        <div class="row mt-2 pl-5" *ngIf="displayCount>0">
          <div class="col-12">
            {{displayCount}} results found for you
          </div>
        </div>



        <div class="history-layout mt-4 pb-5 mb-5" *ngIf="historyList.length > 0">

          <div class="row meeting-row mt-2 ml-0 pr-3 " style="cursor: pointer;"
            *ngFor="let item of historyList| filter:searchText|paginate: { itemsPerPage:pageSize,currentPage: page,totalItems:displayCount } ;let i=index;">
            <div class="col-1 date">
              <p>{{formatDate(item?.mstart,'date')}}</p>
              <p class="month">{{formatDate(item?.mstart,'month')}}</p>
            </div>
            <div (click)="navigateToDetail(item?.invitationID)" class="col-8 pl-4 pt-1">
              <div style="display: flex;">
                <p class="name" *ngFor="let name of item?.t0600Vmsguests|slice:0:2;last as isLast">
                  {{name?.fullName|titlecase}}<span *ngIf="!isLast" class="pr-1">,</span></p><span class="name"
                  *ngIf="item?.t0600Vmsguests?.length>2">+ {{item?.t0600Vmsguests?.length-2}} more</span>
              </div>
              <p class="detail">Booked on {{formatDate(item?.createdDate,'format')}}</p>
            </div>
            <div class=""></div>
            <div class="col-3 align-right">
              <button class="orange-text" *ngIf="item?.isApproved==null&&checkDate(item?.mstart)">Approval awaited !</button>
              <button  *ngIf="item?.isApproved==null&&!checkDate(item?.mstart)">Missed Approval</button>

              <button *ngIf="item?.isApproved==true">Approved</button>
              <div>
                <button *ngIf="item?.isApproved==false">{{item.remarks=='Auto Rejected'?'Missed Approval':'Rejected'}}</button><img
                  style="cursor:pointer;height:25px;width:25px;" src="assets/images/ButtonInfo.png" class="hc"
                  *ngIf="item?.isApproved==false"
                  (mouseout)="openOptionDrawerHistory[i] = !openOptionDrawerHistory[i];globalIndex1 = i"
                  (mouseover)="openOptionDrawerHistory[i] = !openOptionDrawerHistory[i];globalIndex1 = i" />
              </div>
              <div *ngIf="openOptionDrawerHistory[i]" class="drawer-container-hc hc">
                <div class="popup-title-hc hc">Action taken on {{item.approvalDate | customDate}}</div>
                <div class="popup-input-hc hc" style="display: flex;align-items: baseline;">
                  <span class="hc" style="color: #AAAAAA;">Comment :&nbsp;</span>
                  <p class="hc comment" style="color: #01539A;">{{item.remarks}}</p>
                </div>
              </div>
            </div>
          </div>



          <div class="d-flex justify-content-center pagination-section" *ngIf="displayCount>10">
            <div class="row d-flex pagination-border">
              <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)"
                nextLabel="" class="d-flex justify-content-center">
              </pagination-controls>
              <div class="pr-3 ratio-class pt-1" *ngIf="historyList?.length>=10">
                {{page}}/{{paginationCount(displayCount)}}</div>
            </div>
          </div>


        </div>

        <ng-container *ngIf="historyList.length <= 0">
          <empty-state></empty-state>
        </ng-container>


      </div>
    </div>
